import { render, staticRenderFns } from "./CoverageReportList.vue?vue&type=template&id=21514b1d"
import script from "./CoverageReportList.vue?vue&type=script&lang=js"
export * from "./CoverageReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports